// import Cookies from 'js-cookie'
import store from '@/store'

export function getToken() {
  return localStorage.getItem('TokenKey')
}

export function setToken(token) {
  localStorage.setItem('TokenKey', token)
  // console.log('token setted: ', localStorage.getItem('TokenKey'))
}

export function removeToken() {
  return localStorage.removeItem('TokenKey')
}

export function getSidebarMenuList() {
  return store.getters['app/getSidebarMenuList']
}

export function setSidebarMenuList(data) {
  store.dispatch('app/setSidebarMenuList', data)
  let sidebar = JSON.parse(localStorage.getItem('sidebar'))
  sidebar = {
    ...sidebar,
    menu: {
      ...sidebar?.menu,
      menuList: data
    }
  }
  localStorage.setItem('sidebar', JSON.stringify(sidebar))
}

export function setSidebarMenuLink(link) {
  store.dispatch('app/setSidebarMenuLink', link)
  let sidebar = JSON.parse(localStorage.getItem('sidebar'))
  sidebar = {
    ...sidebar,
    menu: {
      ...sidebar?.menu,
      menuLink: link
    }
  }
  localStorage.setItem('sidebar', JSON.stringify(sidebar))
}

export function getIdPassword() {
  return null
}

export function setIdPassword() {}
export function deleteLogInfo() {}
export function saveUserData(data) {
  console.log('Save User', data)

  // Lưu vào localStorage
  localStorage.setItem('UserInfo', JSON.stringify(data))

  // Gọi action của Vuex để set user vào state
  store.dispatch('userInfo/setUserInfo', data)
}
